<template>
  <div class="unBound">
    <div v-for="(item, i) in couponList" :key="i" class="unboundcell">
      <div
        class="unBoundTitle"
        v-if="item.showType === 4 || item.showType === 1 || item.showType === 3 || item.couponsSource == 1"
        :class="[item.showType === 1 ? 'unBoundTitle-orange' : 'unBoundTitle-blue']"
      >
        <div class="information">
          <div clsss="info">
            <div class="sign" v-if="item.couponsSource == 1">
              <img src="~@/assets/ZHLlogo.png" class="icon" alt="优惠券标记" />
              <span class="text">智慧脸商城可用</span>
            </div>
            <div class="sign" v-else>
              <img src="~@/assets/YBMlogo.png" class="icon" alt="优惠券标记" />
              <span class="text">药帮忙可用</span>
            </div>
            <div class="money">
              <span class="symbol">￥</span>
              <span class="currency">{{ item.moneyInVoucher }}</span>
            </div>
            <div v-if="item.minMoneyToEnable" class="fullNumber">{{ item.minMoneyToEnableDesc }}</div>
            <div v-if="item.couponsSource == 1 && item.maxAppointMoneyInCouponDesc" class="fullNumber">{{ item.maxAppointMoneyInCouponDesc}}</div>
            <div v-if="!item.minMoneyToEnable" class="fullNumber">无门槛使用</div>
          </div>
        </div>
        <div class="describe">
          <div class="descTitle">
            <div v-if="item.showType === 1" class="title">智慧脸达标专享</div>
            <popoverTitle :cont-title="item.voucherTitle" :code-type="'2'">
              <div class="title" v-if="item.showType !== 1">{{ item.voucherTitle }}</div>
            </popoverTitle>
            <div class="reward" :class="[item.showType === 1 ? 'reward-orange' : '']">
              {{ transCoupon(item.voucherType) }}
            </div>
          </div>

          <div v-if="item.showType === 3 || item.couponsSource == 1" class="goBind">{{ item.validDateStr }}-{{ item.expireDateStr }}</div>
          <div class="progrego" v-if="item.showType === 4">
            <span class="processNum">
              <van-progress :percentage="item.receivePercent * 100" :show-pivot="false" color="#FEC371" />
            </span>
            <span class="standard">券已领{{ Math.round(item.receivePercent * 100) }}%</span>
          </div>

          <div class="rule" v-if="item.showType === 1">
            <div class="iconInfo">
              <img src="~@/assets/prob.png" />
            </div>
            <popoverRule>
              <div class="ruleDesc">规则说明</div>
            </popoverRule>
          </div>
        </div>
        <div class="bind">
          <van-button round type="info" v-if="item.showType === 4" @click="goReceive(item)">立即领取</van-button>
          <van-button round type="info" v-if="item.showType === 3" @click="goUse(item)">立即使用</van-button>
          <van-button
            round
            type="info"
            v-if="item.couponsSource == 1"
            :class="{ disabled: !item.useable }"
            :disabled="!item.useable"
            @click="goUseZHL(item)"
            >立即使用</van-button
          >
          <div class="progre" v-if="item.showType === 1">
            <span class="processNum">
              <popover :bar-list="proBar.standardsDataList" :rule-level="proBar.standardsRuleVersion" :type-code="typeCode">
                <van-progress :percentage="proBar.ratio" color="#FEC371" :pivot-text="'已达标' + proBar.ratio + '%'" />
              </popover>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// const Base64 = require("js-base64").Base64
import { getCoupons, getYBmPassWord } from "@/api/newHome"
import popover from "../popover/index.vue"
import popoverRule from "../popover/rule"
import popoverTitle from "../popover/title"
import { toast } from "@/utils/index"
import { isAndIos } from "@/utils/auth.js"
import { goECIos, goECAnd } from "@/utils/goEc.js"

export default {
  components: { popover, popoverRule, popoverTitle },
  props: {
    // 优惠券列表
    couponList: {
      type: Array,
      default: () => []
    },
    // 机构信息
    organSign: {
      type: Object,
      default: () => {}
    },
    proBar: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showBind: false,
      voucherTemplateId: 0,
      merchantId: 0,
      Source: "",
      typeCode: 2,
      voucherType: 0 //判断跳转地址
    }
  },
  methods: {
    transCoupon(voucherType) {
      const obj = {
        1: "通用券",
        2: "限部分商品",
        4: "礼品券",
        5: "新人券",
        6: "叠加券",
        7: "返利券",
        8: "全场通用"
      }
      return obj[voucherType]
    },
    // 立即领取
    async goReceive(item) {
      try {
        window.webSdk.track("pCkgtgLm", { type: "已绑定-立即领取" })
        const templateId = item.templateId
        const res = await getCoupons({ voucherTemplateId: templateId })
        if (res.code === 0) {
          toast("恭喜你，领取成功！")
          this.$emit("change", "")
        }
      } catch (error) {
        toast(`领取失败,${error}`)
        this.$emit("change", "")
      }
    },
    async goUse(item) {
      window.webSdk.track("pCkgtgLm", { type: "已绑定-立即使用" })
      this.voucherTemplateId = item.templateId || item.voucherTemplateId
      this.voucherType = item.voucherType //券类型
      //  H5页面不需要登录
      const resPaWd = await getYBmPassWord({})
      if (resPaWd.code === 0) {
        // 创建一个 form
        this.merchantId = resPaWd.result.bindCode.substring(4)
        if (isAndIos()) {
          // 商品券
          if (this.voucherType === 2) {
            this.Source = `coupon_id=${this.voucherTemplateId}&saasOrderSourcePath=81&merchantId=${this.merchantId}`
            goECAnd(this.Source, 1, 2)
          } else {
            this.Source = `voice=ALL&saasOrderSourcePath=81&merchantId=${this.merchantId}`
            goECAnd(this.Source, 1, 1)
          }
        } else {
          // 商品券
          if (this.voucherType === 2) {
            this.Source = `coupon_id=${this.voucherTemplateId}&saasOrderSourcePath=61&merchantId=${this.merchantId}`
            goECIos(this.Source, 1, 2)
          } else {
            this.Source = `voice=ALL&saasOrderSourcePath=61&merchantId=${this.merchantId}`
            goECIos(this.Source, 1, 1)
          }
        }
      }
    },
    goUseZHL(item) {
      window.location.href = "http://xmall.ybm100.com/#/?fromCoupon=true"
    }
  }
}
</script>
<style scoped>
.unboundcell {
  margin-bottom: 10px;
}
.unBound {
  width: 345px;
}
.unBoundTitle {
  display: flex;
  width: 345px;
  height: 110px;
  background-size: 100% 100%;
  position: relative;
}
.unBoundTitle-blue {
  background: url("~@/assets/boundGeneral.png") no-repeat;
  background-size: 100% 100%;
}
.unBoundTitle-orange {
  background: url("~@/assets/boundReward.png") no-repeat;
  background-size: 100% 100%;
}
.information {
  text-align: center;
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sign {
  margin-top: -5px;
  height: 20px;
  line-height: 20px;
  width: 100%;
}
.icon {
  width: 11px;
  height: 11px;
  border: none;
  margin-right: 2px;
  vertical-align: middle;
}
.disabled {
  background: linear-gradient(270deg, rgba(222, 222, 222, 100) 0%, rgba(158, 158, 158, 100) 100%) !important;
}
.ZHL-flag{
  color: #FD8364;
  font-size: 12px;
  flex: auto;
}
.text {
  color: #fff;
  font-size: 11px;
  vertical-align: middle;
}
.symbol {
  font-size: 14px;
  color: #ffffff;
  font-weight: 600;
  margin-right: -2px;
}
.currency {
  font-family: "Alternate";
  font-size: 35px;
  color: #ffffff;
  letter-spacing: -1px;
  margin-right: 6px;
}
.fullNumber {
  font-family: "Alternate";
  font-size: 11px;
  color: #ffffff;
  font-weight: 400;
}
.describe {
  width: 220px;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
}
.descTitle {
  height: 60px;
}
.bind {
  position: absolute;
  top: 35%;
  right: 12px;
}
.describe .title {
  font-family: PingFangSC-Medium, PingFang SC;
  width: 215px;
  height: 22px;
  font-size: 16px;
  font-weight: 700;
  color: #404159;
  margin: 12px 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reward {
  font-family: PingFangSC-Semibold, PingFang SC;
  background: linear-gradient(270deg, rgba(255, 89, 71, 1) 0%, rgba(254, 158, 97, 1) 100%);
  font-size: 11px;
  font-weight: 600px;
  color: #ffffff;
  text-align: center;
  border-radius: 1px;
  display: table;
  padding: 1px 4px;
}
.reward-orange {
  background: linear-gradient(to right, #ffc774, #f9a15b) !important;
}
.goBind {
  font-family: PingFangSC-Regular, PingFang SC;
  /* height: 50px; */
  font-size: 12px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 22px;
}
.progrego {
  width: 140px;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.progrego .processNum {
  display: flex;
}
.progrego .processNum .van-progress /deep/.van-progress__portion {
  background: #ff5947 !important;
}
.progrego .processNum .van-progress {
  width: 60px;
  height: 8px;
  display: inline-block;
  background: #ffffff;
  border: 1px solid #f5f5f5;
}
.standard {
  height: 16px;
  font-size: 12px;
  font-weight: 600;
  color: #ff6218;
  line-height: 16px;
  margin-left: 4px;
}
.rule {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.iconInfo {
  width: 14px;
  height: 14px;
  margin-bottom: 1px;
  margin-right: 2px;
}
.iconInfo img {
  width: 14px;
  height: 14px;
  font-weight: 700;
  display: block;
}
.ruleDesc {
  height: 16px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 16px;
}
.bind {
  display: flex;
  align-items: center;
}
.van-button {
  border: none;
  width: 80px;
  height: 28px;
  line-height: 28px;
  background: linear-gradient(270deg, rgba(254, 88, 1, 1) 0%, rgba(254, 163, 28, 1) 100%);
  /* display: flex;
  justify-content: center; */
}
.van-button__text {
  font-family: PingFangSC-Semibold, PingFang SC;
  height: 16px;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  line-height: 16px;
  display: flex;
}

.bind .progre {
  width: 80px;
  height: 28px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.bind .progre .van-progress /deep/.van-progress__portion {
  width: 80px;
  height: 28px;
  border-radius: 0;
  background: linear-gradient(90deg, rgba(255, 199, 116, 1) 0%, rgba(249, 161, 91, 1) 40%);
}
.bind .progre .van-progress /deep/.van-progress__pivot {
  font-family: "mount";
  font-family: PingFangSC-Regular, PingFang SC;
  background-color: transparent !important;
  width: 80px;
  height: 17px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 98, 24, 1);
  line-height: 17px;
}
.bind .progre .processNum {
  width: 80px;
  height: 28px;
  display: flex;
}
.bind .progre .van-progress {
  width: 78px;
  height: 26px;
  display: inline-block;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  border-radius: 42px;
  overflow: hidden;
}
</style>
